import { useEffect } from 'react';
import Page from 'modules/app/components/Page';
import ProfileTop from './ProfileTop';
import styles from './Profile.module.scss';
import TopMenuProfileTop from './TopMenuProfileTop';
import supabase from 'sdk/api';
import useIsAuth from 'sdk/hooks/useIsAuth';

function Profile() {
  const { data: isAuthData } = useIsAuth();
  const userId = isAuthData?.user?.id;

  const handleUsersTimeZone = async () => {
    const { error } = await supabase
      .from('user_profiles')
      .update({
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      })
      .eq('id', userId);

    if (error) {
      console.error(`Error updating user timezone: ${error.message}`);
    }
  };

  const getUserIP = async () => {
    const res = await fetch('https://api64.ipify.org?format=json');
    const data = await res.json();
    return data.ip;
  };

  const getCountryFromIP = async ip => {
    const res = await fetch(`https://ipapi.co/${ip}/json/`);
    const data = await res.json();
    return data.country_name;
  };

  const updateCountryByIp = async () => {
    try {
      const ip = await getUserIP();
      const country = await getCountryFromIP(ip);

      const { data, error } = await supabase
        .from('user_profiles')
        .update({ country_by_ip: country })
        .eq('id', userId);

      if (error) throw new Error(error.message);

      return data;
    } catch (err) {
      console.error('Ошибка при добавлении поста:', err);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    handleUsersTimeZone();

    updateCountryByIp();
  }, []);

  return (
    <Page activeLink="/profile">
      <TopMenuProfileTop />
      <div className={styles.container}>
        <div className={styles.containerInner}>
          <ProfileTop />

          {/* <Tabs
            className={styles.tabs}
            value={tab}
            items={tabs}
            onSelect={setTab}
            inline
          />
          {(tab === 2 && profile?.id) ? (
            <Content userId={profile?.id || ''} />
          ) : null}
          {(tab === 3) ? (
            <Activity
              userId={profile?.id || ''}
              isOwnProfile={isOwnProfile}
            />
          ) : null}
          {(tab === 4) ? (
            <About userId={profile?.id || ''} />
          ) : null} */}
        </div>
      </div>
    </Page>
  );
}

export default Profile;
